import { useCallback } from 'react';
import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { useGetUserProfile } from '@telus-alberta-health-web/shared-module';
import { useUpdateUserProfile } from 'hooks/use-personal-information/use-personal-information.hook';
import {
  FEATURE_FLAGS,
  MY_HEALTH_REDESIGN_ANNOUNCEMENT_MODAL_SEEN_FIELD,
} from 'common/constants';

const SEEN_VALUE = 'true';

export const useChangeAnnouncementModal = () => {
  const { data, isSuccess } = useGetUserProfile();
  const { data: isRedesignEnabled } = useFeatureFlagQuery(
    FEATURE_FLAGS.MY_HEALTH_REDESIGN_ENABLED,
  );
  const updateUserProfile = useUpdateUserProfile();

  const hasSeenModal = Boolean(
    data?.customFields?.some(
      (field) =>
        field.name === MY_HEALTH_REDESIGN_ANNOUNCEMENT_MODAL_SEEN_FIELD &&
        field.value === SEEN_VALUE,
    ),
  );

  // Gate on the profile having loaded, else an already-seen user is re-presented while data is undefined.
  const shouldPresentModal =
    isSuccess && isRedesignEnabled === true && !hasSeenModal;

  const markModalAsSeen = useCallback(() => {
    // No-op while the redesign is off: never write the seen-field (including
    // the onboarding seed), so a user who onboards pre-rollout can still get
    // the modal once the flag turns on.
    if (isRedesignEnabled !== true) return Promise.resolve();
    return updateUserProfile({
      customFields: [
        {
          name: MY_HEALTH_REDESIGN_ANNOUNCEMENT_MODAL_SEEN_FIELD,
          value: SEEN_VALUE,
        },
      ],
    });
  }, [updateUserProfile, isRedesignEnabled]);

  return { shouldPresentModal, hasSeenModal, markModalAsSeen };
};
